import { useEffect } from 'react'
import { Outlet, RouteObject, useMatches } from 'react-router-dom'
import NavBar from '@components/configurations/Navbar'
import Sidebar from '@components/configurations/sidebar'
import { AppBar, Box, styled } from '@mui/material'
import { AppRouteObject } from '@contexts/Meta'

export const Configurations = () => {
	const matches = useMatches();
	
	const hideSideBar: boolean = (matches[matches.length - 1] as AppRouteObject).handle?.hideSidebar ?? false;
	const Main = styled('main')(({ theme }) => ({
		height: 'calc(100vh - 75px);',
		width: 'inherit !important',
		flexGrow: 1,
		margin: '80px 0px 0px 0px',
		padding: '15px',
		backgroundRepeat: 'no-repeat',
		backgroundAttachment: 'fixed',
		overflow: 'auto',
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
	}))

	return (
		<Box sx={{ display: 'flex', height: '100vh' }}>
			<AppBar  enableColorOnDark position="fixed" color="inherit" elevation={0} sx={{ zIndex: 999 }}>
				<NavBar hideSideBar={hideSideBar}/>
			</AppBar>
			{!hideSideBar && <Sidebar />}
			<Main>
				<Outlet />
			</Main>
		</Box>
	)
}
